/** `/c/$companyId/purchases/credits/$creditId?tab` — a supplier credit (the bill page for credits). */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DOC_PAGE_TABS } from "../api/codes";
import { SupplierDocPage } from "../bills/page/SupplierDocPage";

const search = z.object({
  tab: z.enum(DOC_PAGE_TABS).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/credits/$creditId")({
  validateSearch: (raw) => search.parse(raw),
  component: CreditRoute,
});

function CreditRoute(): JSX.Element {
  const { companyId, creditId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <SupplierDocPage companyId={companyId} kind="vendor-credits" docId={creditId} tab={tab} />;
}
